import React from "react";
import {Box, Button, DialogContent, DialogContentText, Typography} from "@mui/material";
import {ReactComponent as GoogleIcon} from '../assets/google-logo.svg'
import {ReactComponent as MicrosoftIcon} from '../assets/Microsoft_logo.svg'

export default function LoginView({handleClose, handleLogin, privacy}) {
    const login = (isMicrosoft) => {
        handleLogin(isMicrosoft);
        handleClose();
    }
    return (<>
        <DialogContent sx={{marginBottom: "8px"}}>
            <DialogContentText>
                Get the most out of sidebae by signing in. Save and subscribe to searches, block sellers and countries,
                and
                more.
            </DialogContentText>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                gap="12px"
            >
                <Button sx={{padding: '1em', marginTop: "36px"}}
                        startIcon={<GoogleIcon style={{width: '22px', height: 'auto', marginRight: '0.5em'}}/>}
                        onClick={() => login()}>
                    <Typography sx={{textTransform: 'none'}}>Sign in with Google</Typography>
                </Button>
                <Button sx={{padding: '1em'}}
                        startIcon={<MicrosoftIcon style={{width: '22px', height: 'auto', marginRight: '0.5em'}}/>}
                        onClick={login}>
                    <Typography sx={{textTransform: 'none'}}>Sign in with Microsoft</Typography>
                </Button>
            </Box>

        </DialogContent>
    </>)
}